import PageViewer from "@/components/PageViewer";
import FvuStore from "@/store/modules/fvu";
import PERMISSIONS from "@/common/permissions-lib";

const fvuProps = route => {
	return {
		fvuId: route.params.fvuId,
		deviceIdentifier: route.params.fvuId,
		deviceType: "fvu",
		device: route.params.device
	};
};

export default {
	path: "/VUFeed",
	meta: {
		breadcrumb: "TFM-VU Feed",
		authorizedRoles: [PERMISSIONS.RSU_VU_FEED_VIEW]
	},
	component: PageViewer,
	props: { pageTransition: "none" },
	children: [
		{
			path: "/",
			name: "VUFeed",
			props: { pageTransition: "none" },
			component: () =>
				import(/* webpackChunkName: "VUFeed" */ "@/views/VUFeed/Index")
		},
		{
			path: ":fvuId",
			name: "VUFeed.byFvuId",
			props: fvuProps,
			meta: {
				breadcrumb() {
					const fvu = this.$store.getters[
						`${FvuStore.MODULE_NAME}/byIdentifier`
					](this.$route.params.fvuId);
					return "VUnit: " + ((fvu && fvu.displayName) || "...");
				}
			},
			component: () =>
				import(
					/* webpackChunkName: "VUFeed.byVUnitId" */ "@/views/VUFeed/ByVUnitId/Index"
				),
			children: []
		}
	]
};
